import { ActionIcon, Group } from "@mantine/core";
import { IconStar, IconStarFilled } from "@tabler/icons-react";

interface Props {
  label: string;
  favourite: boolean;
  onToggleFavourite: () => void;
}

const ReportTypeOption = ({ label, favourite, onToggleFavourite }: Props) => (
  <Group justify="space-between" wrap="nowrap" w="100%">
    <span>{label}</span>
    <ActionIcon
      variant="transparent"
      style={{
        color: favourite ? "var(--mantine-color-yellow-5)" : "inherit",
      }}
      aria-label={favourite ? "Remove from favourites" : "Add to favourites"}
      aria-pressed={favourite}
      onMouseDown={event => {
        event.preventDefault();
        event.stopPropagation();
      }}
      onClick={event => {
        event.stopPropagation();
        onToggleFavourite();
      }}>
      {favourite ? (
        <IconStarFilled size="1.1rem" />
      ) : (
        <IconStar size="1.1rem" />
      )}
    </ActionIcon>
  </Group>
);

export default ReportTypeOption;
